import { composeAPI, intoLines } from "../Common/api";
import dpiComposition from "./composition";

const firstColumn = (line) => line.split(/\s+/).at(0);

const nonRepeatedNames = (present, name) =>
  present.has(name) ? present : present.add(name);

const parseNamesAsList = (input) => {
  const [_head, ...lines] = intoLines(input);
  return Array.from(lines.map(firstColumn).reduce(nonRepeatedNames, new Set()));
};

const parseSignatureOf = (name) => (line) => {
  const [host, priority, type] = line.trim().split(/\s+/);
  return { name, host, type, priority };
};

const parseSignaturesOf = (name) => (input) => {
  const [_head, ...lines] = intoLines(input);
  return lines.map(parseSignatureOf(name));
};

const loadProfiles = (names) =>
  ifCl
    .run(names.map((name) => `show profile '${name}'`).join("\n") + "\n", true)
    .then((response) =>
      response
        .replaceAll(/,(?!HOST)/g, "")
        .split(",")
        .map((part, index) => parseSignaturesOf(names[index])(part))
    );

const loadProfile = (name) =>
  ifCl
    .run(`show profile '${name}'`)
    .then((response) => parseSignaturesOf(name)(response));


const HEADER = ["NAME", "PATTERN", "TYPE", "PRIORITY"];

const sizeOfCells = (input) => input.map((value) => value.length);

const longerSizes = (one, other) =>
  one.map((value, index) => (value > other[index] ? value : other[index]));

const intoRowsAndCellSize = ({ rows = [], sizes = [] }, row) => ({
  rows: [...rows, row],
  sizes: longerSizes(sizes, sizeOfCells(row)),
});

const renderRows = ({ rows, sizes }) =>
  [HEADER, ...rows]
    .map((cells) =>
      cells
        .map((cell, index, { length }) =>
          index === length - 1
            ? String(cell).padStart(sizes[index])
            : String(cell).padEnd(sizes[index])
        )
        .join(" ")
    )
    .join("\n") + "\n";

const squashIntoTable = (requestResults) =>
  renderRows(
    Array.from(requestResults)
      .flat()
      .map(({ name, host, type, priority }) => [name, host, type, priority])
      .reduce(intoRowsAndCellSize, { rows: [], sizes: sizeOfCells(HEADER) })
  );

const loadAll = ({ cliType }, profileName) => {
  if (profileName) {
    return loadProfile(profileName).then(squashIntoTable);
  } else {
    return ifCl
      .run(`show profile ${cliType}`)
      .then(parseNamesAsList)
      .then(loadProfiles)
      .then(squashIntoTable);
  }
};

export const composedAPI = composeAPI({ loadAll, ...dpiComposition });
